import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import {
  formatDateString,
  getExpandedItems,
} from "./fulfillment-group-csv-utils";

const variantCustomDateKeys = [
  "variantCustomDate1",
  "variantCustomDate2",
  "variantCustomDate3",
] as const;

export function getVariantCustomDateCsvColumn(
  title: string,
  key: (typeof variantCustomDateKeys)[number],
): FulfillmentGroupCsvColumn<FulfillmentGroupData> {
  return {
    header: title,
    cell: (row: FulfillmentGroupData) => {
      const values = new Set<string>();
      for (const item of getExpandedItems(row)) {
        const value = item[key];
        if (value) {
          values.add(formatDateString(value, true));
        }
      }
      return values.size > 0 ? Array.from(values).join(", ") : "";
    },
    expandedCsvCell: (row: FulfillmentGroupData, expansionIndex: number) => {
      const lineItem = getExpandedItems(row)?.[expansionIndex];
      const value = lineItem?.[key];
      return value ? formatDateString(value, true) : "";
    },
  };
}
